export function getTabletDesktopStyles() {
  return require('./styles.module.css');
}